import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { pluralization } from '@utils/intl-helpers'
import {
  OfferStatusModeration,
  
} from '@/modules/cabinet/modules/Offers/const'


export default /*@__PURE__*/_defineComponent({
  __name: 'ProductMainPreview',
  props: {
    item: {}
  },
  emits: ["favorite-change"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props

const { origin } = window.location

const emit = __emit

const { t } = useI18n()
const FinancingPeriodPlurals = {
  one: t('month'),
  few: t('months'),
  many: t('months'),
}
const pluralFinancingPeriod = computed(() =>
  pluralization(FinancingPeriodPlurals, props.item.defaultPeriod || 60)
)

function onChangeFavorite(state: boolean) {
  emit('favorite-change', { id: props.item.id, state })
}

function onChangeComparison(state: boolean) {
  emit('comparison-change', { id: props.item.id, state })
}

const __returned__ = { props, origin, emit, t, FinancingPeriodPlurals, pluralFinancingPeriod, onChangeFavorite, onChangeComparison, computed, get useI18n() { return useI18n }, get pluralization() { return pluralization }, get OfferStatusModeration() { return OfferStatusModeration } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})